export const startWithType = <P extends {}> () => (props: P) => props
